import React, { FunctionComponent, useEffect } from "react";
import { Unsubscribe, onSnapshot, getFirestore, collection } from 'firebase/firestore';

import styles from './resetCompanyNotifications.module.scss';
import { getTranslations } from "../../features/translations/translationsUtils";
import { firebaseApp } from "../../services/firebase";
import { useDispatch } from "react-redux";
import { Button } from "antd";
import { resetCompanySuccess } from "../../features/company/companySlice";

const NOTIFICATION_RESET_COLLECTION = 'companyResetNotification';
const db = getFirestore(firebaseApp);

interface INotification {
  companyName?: string;
  ready: boolean;
  type: 'invitations' | 'reset';
  userCount: number;
  usersDone: number;
}

export const ResetCompanyNotifications: FunctionComponent = () => {
  const dispatch = useDispatch();
  const [notification, setNotification] = React.useState<INotification | null>(null);
  const [notificationId, setNotificationId] = React.useState<string | null>(null);
  useEffect(() => {
    const collectionRef = collection(db, NOTIFICATION_RESET_COLLECTION);
    const unsubscribe: Unsubscribe = onSnapshot(
      collectionRef,
      { includeMetadataChanges: true },
      (querySnapshot) => {
        let lastNotification: INotification | null = null;
        let lastNotificationId: string | null = null;
        querySnapshot.forEach((doc) => {
          const data = doc.data() as INotification;
          if (data.ready) {
            return false;
          }
          lastNotification = data;
          lastNotificationId = doc.id;
        });


        if (notificationId !== null && lastNotificationId === null) {
          setNotification({
            ...(notification ?? {} as INotification),
            ready: true,
            usersDone: notification?.userCount ?? 0,
          });
          setNotificationId(lastNotificationId);
          return;
        }
        setNotification(lastNotification);
        setNotificationId(lastNotificationId);
        if (lastNotification === null) {
          setNotificationId(null);
          dispatch(resetCompanySuccess())
        }
      }
    );
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, notificationId]);

  if (!notification) {
    return null;
  }
  console.log("🚀 ~ ResetCompanyNotifications ~ notification:", notification)
  const renderCloseButton = () => {
    if (!notification.ready) {
      return null;
    }
    return <Button
      onClick={() => {
        setNotification(null);
        dispatch(resetCompanySuccess());
      }}
      type="text">{getTranslations("COMPANY_RESETTING_IN_PROGRESS_CLOSE")}</Button>;
  };
  if (notification.type === 'invitations') {
    return <div className={styles.container}>
      <div>
        {getTranslations("USERS_RESEND_INVITATIONS_IN_PROGRESS")}:
      </div>
      <div>
        {notification.usersDone}/{notification.userCount} {getTranslations("COMPANY_RESETTING_IN_PROGRESS_USERS")} {renderCloseButton()}
      </div>
    </div>;
  }
  return <div className={styles.container}>
    <div>
      {getTranslations("COMPANY_RESETTING_IN_PROGRESS")}:
    </div>
    <div className={styles.companyName}>
      {notification.companyName}:
    </div>
    <div>
      {notification.usersDone}/{notification.userCount} {getTranslations("COMPANY_RESETTING_IN_PROGRESS_USERS")} {renderCloseButton()}
    </div>
  </div>;
}